(() => {
  function init(root) {
    if (!root || root.dataset.quizInit === '1') return;
    root.dataset.quizInit = '1';

    const slides = Array.from(root.querySelectorAll('.quiz-slide'));
    const totalsEls = Array.from(root.querySelectorAll('.quiz-total'));
    const confirmWrap = root.querySelector('.quiz-confirm');

    const PHRASE_KEY = `quizPhrase`;
    const URL_PREFIX = 'https://store.betterme.world/collections/';
    const urlSegs = new Map();

    const totalCount = Math.max(0, slides.length - 1);
    totalsEls.forEach(el => (el.textContent = String(totalCount)));

    let index = 0;
    let redirected = false;
    let redirectUrlFromQ2 = null;
    const savedAnswers = new Map();

    function getCurrentSlide() {
      return slides[index];
    }
    function getBackButton() {
      return getCurrentSlide()?.querySelector('.quiz-back');
    }
    function getNextButton() {
      return getCurrentSlide()?.querySelector('.quiz-next');
    }
    function getStepEls() {
      return Array.from(root.querySelectorAll('.quiz-step'));
    }
    function getForm() {
      return getCurrentSlide()?.querySelector('.quiz-form');
    }
    function getMobileSteps() {
      return getCurrentSlide()?.querySelector('.quiz-mobile-steps');
    }
    function isLoaderSlide(slide) {
      const s = slide || getCurrentSlide();
      return !!(
        s &&
        (s.dataset.kind === 'loader' || s.querySelector('.loader-ring'))
      );
    }
    function currentProgressIndex() {
      return isLoaderSlide()
        ? Math.max(0, totalCount - 1)
        : Math.min(index, Math.max(0, totalCount - 1));
    }

    function setStep() {
      const cur = getCurrentSlide();
      const isLoader = isLoaderSlide(cur);
      const currentNum = isLoader
        ? totalCount
        : Math.min(index + 1, totalCount);
      getStepEls().forEach(el => (el.textContent = String(currentNum)));
    }
    function toggleBackVisibility() {
      const btn = getBackButton();
      if (!btn) return;
      const hide = index === 0;
      btn.disabled = hide;
      btn.classList.toggle('lg:tw-hidden', hide);
      btn.classList.toggle('tw-invisible', hide);
    }
    function buildAllMobileSteps() {
      slides.forEach(s => {
        const wrap = s.querySelector('.quiz-mobile-steps');
        if (!wrap) return;
        wrap.innerHTML = '';
        for (let k = 0; k < totalCount; k++) {
          const dash = document.createElement('span');
          dash.className =
            'dash ' + (k === 0 ? 'dash--active' : 'dash--upcoming');
          wrap.appendChild(dash);
        }
      });
    }
    function updateMobileSteps(step) {
      const wrap = getMobileSteps();
      if (!wrap) return;

      const items = wrap.children;
      for (let index = 0; index < items.length; index++) {
        const item = items[index];

        item.classList.remove('dash--active', 'dash--passed', 'dash--upcoming');

        if (index < step) item.classList.add('dash--passed');
        else if (index === step) item.classList.add('dash--active');
        else item.classList.add('dash--upcoming');
      }
    }

    function selectedValues() {
      const form = getForm();
      if (!form) return [];
      const inputs = Array.from(form.querySelectorAll('input'));
      return inputs.filter(i => i.checked).map(i => i.value);
    }
    function updateNextState() {
      const btn = getNextButton();
      if (!btn) return;
      const current = savedAnswers.get(index) || selectedValues();
      btn.disabled = current.length === 0;
    }
    function restoreSelections() {
      const form = getForm();
      if (!form) return;
      const values = savedAnswers.get(index) || [];
      const inputs = Array.from(form.querySelectorAll('input'));
      inputs.forEach(inp => {
        inp.checked = values.includes(inp.value);
        const label = inp.closest('.quiz-option');
        if (label) label.classList.toggle('selected', inp.checked);
      });
    }

    function openConfirm() {
      confirmWrap?.classList.add('is-open');
    }
    function closeConfirm() {
      confirmWrap?.classList.remove('is-open');
    }

    function getSelectedFragmentFromSlide(slide) {
      const checked = slide.querySelector('input[data-color]:checked');
      if (!checked) return null;
      const text = (checked.dataset.color || '').trim();
      if (!text) return null;
      const orderAttr = slide.getAttribute('data-phrase-order');
      const order =
        orderAttr != null && orderAttr !== '' && !isNaN(Number(orderAttr))
          ? Number(orderAttr)
          : null;
      const slideIndex = Number(slide.getAttribute('data-index') || '0');
      return { text, order, slideIndex };
    }
    function looksLikeSuffix(text) {
      const t = String(text || '').trim();
      if (!t) return false;
      try {
        return /^\p{Ll}/u.test(t);
      } catch {
        const ch = t[0];
        return ch === ch.toLowerCase() && ch !== ch.toUpperCase();
      }
    }
    function buildAndSavePhrase() {
      const frags = slides.map(getSelectedFragmentFromSlide).filter(Boolean);
      if (!frags.length) {
        localStorage.removeItem(PHRASE_KEY);
        return '';
      }
      frags.forEach(f => {
        if (f.order == null)
          f.order = looksLikeSuffix(f.text)
            ? 100000 + f.slideIndex
            : f.slideIndex;
      });
      frags.sort((a, b) => a.order - b.order);
      const core = frags
        .map(f => f.text)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();
      const phrase = `Your match: ${core}`;
      localStorage.setItem(PHRASE_KEY, phrase);
      root.dispatchEvent(
        new CustomEvent('quiz:phrase', { detail: { phrase } })
      );
      return phrase;
    }

    function collectSlideUrl(slide) {
      const segs = Array.from(slide.querySelectorAll('input[data-url]:checked'))
        .map(i => (i.dataset.url || '').trim())
        .filter(Boolean);
      return segs.join('');
    }
    function rebuildUrlSegsFromDOM() {
      urlSegs.clear();
      slides.forEach((s, i) => {
        const seg = collectSlideUrl(s);
        if (seg) urlSegs.set(i, seg);
      });
    }
    function updateUrlSegForCurrent() {
      const seg = collectSlideUrl(
        getCurrentSlide() || document.createElement('div')
      );
      if (seg) urlSegs.set(index, seg);
      else urlSegs.delete(index);
    }
    function getCollectionUrlIfAny(rebuild) {
      if (rebuild) rebuildUrlSegsFromDOM();
      const slug = Array.from(urlSegs.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([, v]) => v)
        .join('')
        .trim();
      if (!slug) return null;
      return URL_PREFIX + slug.replace(/\/+$/, '');
    }

    function finalizeRedirect() {
      if (redirected) return;
      redirected = true;
      try {
        sessionStorage.setItem('quizRedirected', '1');
      } catch {}
      if (redirectUrlFromQ2) {
        window.location.href = redirectUrlFromQ2;
        return;
      }
      const collectionUrl = getCollectionUrlIfAny(true);
      if (collectionUrl) {
        window.location.href = collectionUrl;
        return;
      }
      const payload = {};
      savedAnswers.forEach((val, idx) => (payload[idx] = val));
      root.dispatchEvent(new CustomEvent('quiz:complete', { detail: payload }));
    }

    function captureDirectRedirectIfQ2() {
      const slide = getCurrentSlide();
      if (!slide) {
        redirectUrlFromQ2 = null;
        return;
      }

      const checked = slide.querySelector('input[data-color]:checked');
      if (!checked) {
        redirectUrlFromQ2 = null;
        return;
      }

      const v = (checked.dataset.color || '').trim();
      if (v && (/^(https?:)?\/\//i.test(v) || v.startsWith('/'))) {
        redirectUrlFromQ2 = v;
      } else {
        redirectUrlFromQ2 = null;
      }
    }

    let loaderState = new WeakMap();
    function resetLoaderVisuals() {
      slides.forEach(s => {
        const progress = s.querySelector('.ring-progress');
        const percentEl = s.querySelector('.loader-percent');
        if (progress) {
          const r = parseFloat(progress.getAttribute('r')) || 45;
          const C = 2 * Math.PI * r;
          progress.style.strokeDasharray = C;
          progress.style.strokeDashoffset = C;
        }
        if (percentEl) percentEl.textContent = '0%';
      });
    }
    function startLoader(slide) {
      if (!slide || loaderState.get(slide)) return;
      const ring = slide.querySelector('.loader-ring');
      const progress = slide.querySelector('.ring-progress');
      const percentEl = slide.querySelector('.loader-percent');
      const nextBtn = slide.querySelector('.quiz-next');
      if (!ring || !progress || !percentEl) return;

      loaderState.set(slide, true);

      const duration = Math.max(0.5, parseFloat(ring.dataset.duration || '3'));
      const radius = 45;
      const C = 2 * Math.PI * radius;

      progress.style.strokeDasharray = C;
      progress.style.strokeDashoffset = C;
      percentEl.textContent = '0%';
      if (nextBtn) nextBtn.disabled = true;
      let startTs = null;
      function tick(ts) {
        if (!startTs) startTs = ts;
        const t = Math.min(1, (ts - startTs) / (duration * 1000));
        const val = Math.round(t * 100);
        progress.style.strokeDashoffset = C * (1 - t);
        percentEl.textContent = val + '%';
        if (t < 1) requestAnimationFrame(tick);
        else {
          dataLayer.push({
            event: 'custom_event',
            event_name: 'quiz_finish',
            parameter: ''
          });
          if (nextBtn) nextBtn.disabled = false;
          if (index === slides.length - 1) finalizeRedirect();
        }
      }
      requestAnimationFrame(tick);
    }
    function startLoaderIfVisible() {
      const slide = getCurrentSlide();
      if (!slide) return;
      if (isLoaderSlide(slide)) startLoader(slide);
    }

    root.__bobQuizApi = {
      resetToFirst() {
        index = 0;
        redirected = false;
        redirectUrlFromQ2 = null;
        savedAnswers.clear();
        urlSegs.clear();
        loaderState = new WeakMap();

        slides.forEach(slide => {
          slide
            .querySelectorAll('input[type="radio"], input[type="checkbox"]')
            .forEach(input => {
              input.checked = false;
            });

          slide
            .querySelectorAll('.quiz-option')
            .forEach(opt => opt.classList.remove('selected'));
        });

        resetLoaderVisuals();
        slides.forEach((s, k) => {
          if (k === 0) {
            s.setAttribute('aria-current', 'true');
          } else {
            s.removeAttribute('aria-current');
          }
        });
        setStep();
        toggleBackVisibility();
        restoreSelections();
        updateNextState();
        updateMobileSteps(0);
        buildAndSavePhrase();
        captureDirectRedirectIfQ2();
      }
    };

    root.addEventListener('change', e => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement)) return;
      const label = input.closest('.quiz-option');
      if (!label) return;

      if (input.type === 'radio') {
        getForm()
          ?.querySelectorAll('.quiz-option')
          .forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');
        savedAnswers.set(index, [input.value]);
      } else {
        label.classList.toggle('selected', input.checked);
        savedAnswers.set(index, selectedValues());
      }
      updateNextState();
      buildAndSavePhrase();
      updateUrlSegForCurrent();
      captureDirectRedirectIfQ2();
    });

    root.addEventListener('click', e => {
      const back = e.target.closest('.quiz-back');
      if (back) {
        showSlide(index - 1);
        buildAndSavePhrase();
        updateUrlSegForCurrent();

        redirectUrlFromQ2 = null;
        captureDirectRedirectIfQ2();

        return;
      }

      const next = e.target.closest('.quiz-next');
      if (next) {
        if (next.disabled) return;
        const vals = selectedValues();
        if (vals.length) savedAnswers.set(index, vals);
        buildAndSavePhrase();
        updateUrlSegForCurrent();
        captureDirectRedirectIfQ2();

        if (redirectUrlFromQ2) {
          finalizeRedirect();
          return;
        }

        if (index < slides.length - 1) {
          showSlide(index + 1);
        } else {
          finalizeRedirect();
        }
        return;
      }

      const skip = e.target.closest('.quiz-skip');
      if (skip) {
        buildAndSavePhrase();
        updateUrlSegForCurrent();
        captureDirectRedirectIfQ2();

        if (redirectUrlFromQ2) {
          finalizeRedirect();
          return;
        }

        if (index < slides.length - 1) {
          showSlide(index + 1);
        } else {
          finalizeRedirect();
        }
        return;
      }

      const closeBtn = e.target.closest('.quiz-close');
      if (closeBtn) {
        openConfirm();
        return;
      }
    });

    confirmWrap?.addEventListener('click', e => {
      const dialog = e.target.closest('.quiz-confirm__dialog');
      const closeBtn = e.target.closest('.quiz-confirm-close');
      if (!dialog || closeBtn) closeConfirm();
    });
    root
      .querySelector('.quiz-confirm-link')
      ?.addEventListener('click', closeConfirm);

    function showSlide(nextIndex) {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach((s, k) =>
        k === index
          ? s.setAttribute('aria-current', 'true')
          : s.removeAttribute('aria-current')
      );
      setStep();
      toggleBackVisibility();
      restoreSelections();
      updateNextState();
      updateMobileSteps(currentProgressIndex());
      startLoaderIfVisible();
      let pageNumber = 1;
      if (nextIndex) pageNumber = nextIndex + 1;
      setTimeout(() => {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'custom_event',
          event_name: 'quiz_page_view',
          parameter: JSON.stringify({
            page_number: `${pageNumber}`
          })
        });
      }, 500);
    }

    (function boot() {
      buildAllMobileSteps();
      showSlide(0);
      buildAndSavePhrase();
      rebuildUrlSegsFromDOM();
    })();
  }

  function initAllInDOM(scope = document) {
    scope.querySelectorAll('[data-quiz-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllInDOM());
  } else {
    initAllInDOM();
  }

  function shouldResetOnBack(event) {
    if (event?.persisted) return true;
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') return true;
    } catch {}
    try {
      if (sessionStorage.getItem('quizRedirected') === '1') return true;
    } catch {}
    return false;
  }

  window.addEventListener('pageshow', event => {
    if (!shouldResetOnBack(event)) return;
    try {
      sessionStorage.removeItem('quizRedirected');
    } catch {}
    document.querySelectorAll('[data-quiz-root]').forEach(root => {
      if (root.__bobQuizApi?.resetToFirst) {
        root.__bobQuizApi.resetToFirst();
        dataLayer.push({
          event: 'custom_event',
          event_name: 'quiz_page_view',
          parameter: JSON.stringify({
            page_number: `1`
          })
        });
      } else {
        root.dataset.quizInit = '0';
        init(root);
      }
    });
  });

  document.addEventListener('shopify:section:load', e => {
    initAllInDOM(e.target || document);
  });
  document.addEventListener('shopify:section:select', e => {
    initAllInDOM(e.target || document);
  });

  window.BOBQuiz = { initAll: initAllInDOM, init };
})();
